import { showErrorNotification } from '@/utils/utils.js';
import { objectToQueryParams } from '@/utils/url';
import logger from '@goldcast/logger';

function checkError(error, { isDelete, isBlock }) {
  const userActionVerb = isDelete ? 'deleting' : isBlock ? 'banning' : 'unbanning';

  try {
    const err = JSON.parse(error);
    if (err.detail) return err.detail;
    return `Error in ${userActionVerb} users. Please try again`;
  } catch (err) {
    return `Error in ${userActionVerb} users. Please try again`;
  }
}

export default {
  // ---------------------- Event User's Actions ---------------------------- //
  async blockEventBulkUsers(context, { eventUsers, eventId }) {
    const url = `/event/${eventId}/bulk_block/`;
    const method = 'POST';
    const body = JSON.stringify({ event_users: eventUsers });
    try {
      const response = await context.dispatch('makeapicall', { url, method, body }, { root: true });
      return response;
    } catch (err) {
      showErrorNotification('Error in banning event users');
      throw err;
    }
  },

  async blockUsersByAppbaseQuery(context, { payload, eventId }) {
    if (!eventId) {
      logger.error('EventId must be defined to block users');
      return;
    }

    const url = `/event/${eventId}/appbase_bulk_block/`;
    const method = 'POST';
    const body = JSON.stringify(payload);
    try {
      await context.dispatch('makeapicall', { url, method, body }, { root: true });
    } catch (err) {
      const errorMessage = checkError(err, { isBlock: true });
      showErrorNotification(errorMessage);
      throw err;
    }
  },

  async bulkUnblockEventUsers(context, { eventUsers, eventId }) {
    const url = `/event/${eventId}/bulk_unblock/`;
    const method = 'POST';
    const body = JSON.stringify({ event_users: eventUsers });
    try {
      const response = await context.dispatch('makeapicall', { url, method, body }, { root: true });
      return response;
    } catch (err) {
      showErrorNotification('Error in unbanning event users');
      throw err;
    }
  },

  async unblockUsersByAppbaseQuery(context, { payload, eventId }) {
    if (!eventId) {
      logger.error('EventId must be defined to unblock users');
      return;
    }

    const url = `/event/${eventId}/appbase_bulk_unblock/`;
    const method = 'POST';
    const body = JSON.stringify(payload);
    try {
      await context.dispatch('makeapicall', { url, method, body }, { root: true });
    } catch (err) {
      const errorMessage = checkError(err, { isUnblock: true });
      showErrorNotification(errorMessage);
      throw err;
    }
  },

  async deleteUsersByAppbaseQuery(context, { payload, eventId }) {
    if (!eventId) {
      logger.error('EventId must be defined to delete users');
      return;
    }

    const url = `/event/${eventId}/appbase_bulk_delete/`;
    const method = 'POST';
    const body = JSON.stringify(payload);
    try {
      await context.dispatch('makeapicall', { url, method, body }, { root: true });
    } catch (err) {
      const errorMessage = checkError(err, { isDelete: true });
      showErrorNotification(errorMessage);
      throw err;
    }
  },

  async deleteEventBulkUsers(context, { eventUsers, eventId }) {
    const url = `/event/${eventId}/bulk_delete/`;
    const method = 'POST';
    const body = JSON.stringify({ event_users: eventUsers });
    try {
      const response = await context.dispatch('makeapicall', { url, method, body }, { root: true });
      return response;
    } catch (err) {
      showErrorNotification('Error in deleting event users');
      throw err;
    }
  },

  async getEventMembers(context, { eventID, params = {} }) {
    context.commit('setEventMembers', []);
    params['event'] = eventID;
    const url = `/event/event-members/?${objectToQueryParams(params)}`,
      method = 'GET';
    context.commit('setEventMembersLoading', true);
    try {
      const response = await context.dispatch('makeapicall', { url, method }, { root: true });
      context.commit('setEventMembers', response?.results ?? []);
      context.commit('setEventMembersCount', response?.count);
    } catch {
      showErrorNotification('Error in Fetching event members');
    } finally {
      context.commit('setEventMembersLoading', false);
    }
  }
};
